'use client';

import { AnimatePresence } from '@tamagui/animate-presence';
import React from 'react';
import { YStack, styled } from 'tamagui';

type Props = {
  visible: boolean;
  height: number;
  children: React.ReactNode;
};

const HeaderContainer = styled(YStack, {
  name: 'AnimatedHeader',
  overflow: 'hidden',
  width: '100%',
  position: 'relative',
  animation: 'medium',
  variants: {
    enter: {
      true: {
        y: 0,
        opacity: 1,
        height: 'auto',
      },
      false: {
        y: -20,
        opacity: 0,
        height: 0,
      },
    },
  } as const,
});

const AnimatedHeader = ({ visible, height, children }: Props) => {
  return (
    <AnimatePresence>
      {visible && (
        <HeaderContainer
          enter={visible}
          style={{
            height,
          }}
        >
          {children}
        </HeaderContainer>
      )}
    </AnimatePresence>
  );
};

export default AnimatedHeader;
